import React from 'react';
import PropTypes from 'prop-types';

import { getItemsCount, getSaleTypes } from 'pages/MyAccount/utils/orders';
import ProductsList from 'pages/MyAccount/Orders/ProductsList';
import CollapsibleBar from '../CollapsibleBar';

const Order = ({
  order,
  index,
  isDesktop,
  onClickOrderDetails,
  trackOrderViewed,
  trackShipment,
}) => {
  const { billingDate, orderTotalInCents, shippingAddress, shipments } = order;
  const saleType = getSaleTypes(shipments);
  const header = {
    saleType,
    billingDate,
    items: getItemsCount(shipments),
    orderTotal: orderTotalInCents / 100,
    shippingAddress,
  };
  const handleTrackOrderViewed = () => trackOrderViewed(order, index + 1);
  const handleClickOrderHeader = () => {
    if (!isDesktop) {
      onClickOrderDetails(order);
      handleTrackOrderViewed();
    }
  };

  return (
    <CollapsibleBar
      openOnLoad={index === 0 || !isDesktop}
      header={header}
      isDesktop={isDesktop}
      onClickOrderHeader={handleClickOrderHeader}
      trackOrderViewed={handleTrackOrderViewed}
    >
      <ProductsList order={order} isDesktop={isDesktop} trackShipment={trackShipment} />
    </CollapsibleBar>
  );
};

Order.propTypes = {
  order: PropTypes.shape({
    billingDate: PropTypes.string,
    orderTotalInCents: PropTypes.number,
    shippingAddress: PropTypes.shape({}),
    shipments: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  index: PropTypes.number.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  onClickOrderDetails: PropTypes.func.isRequired,
  trackOrderViewed: PropTypes.func.isRequired,
  trackShipment: PropTypes.func.isRequired,
};

export default Order;
